import { useEffect, useState } from "react";

// Lazy YouTube embed usando lite-youtube-embed (Paul Irish).
// - Solo carga el iframe al click del usuario (no en initial bundle).
// - Thumbnail JPG de YouTube se muestra mientras tanto.
// - Performance: ahorra ~500KB+ del bundle inicial vs iframe directo.
export default function YouTubeEmbed({ videoId, title = "Video Eclipse Cubiertas", className = "", aspect = "video" }) {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            await import("lite-youtube-embed");
            await import("lite-youtube-embed/src/lite-yt-embed.css");
            if (!cancelled) setReady(true);
        })();
        return () => { cancelled = true; };
    }, []);

    const aspectClass = aspect === "short" ? "aspect-[9/16]" : "aspect-video";

    return (
        <div
            data-testid={`youtube-embed-${videoId}`}
            className={`relative w-full ${aspectClass} rounded-xl overflow-hidden shadow-2xl bg-black ${className}`}
        >
            {ready ? (
                <lite-youtube
                    videoid={videoId}
                    playlabel={title}
                    style={{ backgroundImage: `url(https://i.ytimg.com/vi/${videoId}/hqdefault.jpg)` }}
                >
                    <button type="button" className="lty-playbtn" aria-label={`Reproducir: ${title}`}></button>
                </lite-youtube>
            ) : (
                <img
                    src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
                    alt={title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                />
            )}
        </div>
    );
}
